<template>
    <div class="modal-card">
        <header class="modal-card-head has-background-white">
            <h3 class="modal-card-title has-text-centered">
                Recargar <span>{{ tipo }}</span> desde Fintoc
            </h3>
            <button class="delete" aria-label="Cerrar Modal" @click="$emit('close')"></button>
        </header>
        <section class="modal-card-body">
            <table class="fechas_table">
                <tr>
                    <td class="fecha_title">Desde</td>
                    <td class="fechas_td">
                        <input type="date" name="desdeDate" :value="inidate">
                    </td>
                    <td class="fecha_title">Hasta</td>
                    <td class="fechas_td">
                        <input type="date" name="hastaDate" :value="today">
                    </td>
                </tr>
            </table>
        </section>
        <section class="modal-card-body">
            <div style="text-align: center;">
                <table style="margin: 0 auto;">
                    <tr><td>
                        <p class="log_title">Logs para la empresa {{ this.rutCompany }} </p>
                    </td><td>
                        <img class="spinner" :src="spinner" v-if="intervalId"/>
                    </td></tr>
                </table>
            </div>
            <table class="fintoc_log">
                <tr class="log_row log_header">
                    <td class="log_cell">Periodo</td>
                    <td class="log_cell">Fecha recepcion</td>
                    <td class="log_cell">Filas recibidas</td>
                    <td class="log_cell">Filas grabadas</td>
                    <td class="log_cell">Error</td>
                </tr>
                <tr v-for="row in fintoc_logs" :key="row.id" class="log_row">
                    <td class="log_cell">{{ row.tax_period }}</td>
                    <td :class="['log_cell', 'log_fecha', {'occurred_today': row.occurred_today}]">{{ row.received_date }}</td>
                    <td class="log_cell">{{ row.rows_received }}</td>
                    <td class="log_cell" :class="{'mismatch': row.rows_saved != row.rows_received }">{{ row.rows_saved }}</td>
                    <td class="log_cell">
                        <SimpleButton @click="showError(row)" v-if="row.error_expand"
                            :buttonStyle="`linear-gradient(135deg, #fee0e0, #fee2e2)`"
                            >
                            {{ row.expanded ? 'Contraer' : 'Ver error' }}
                        </SimpleButton>
                        {{ row.error_shown }}
                    </td>
                </tr>
            </table>
        </section>
        <footer class="modal-card-foot bt-none has-background-white is-justify-content-flex-end">
            <button class="button" @click="$emit('close')" aria-label="Cerrar Modal" role="button">
                Volver
            </button>
            <button class="button is-primary"
                :disabled="loading || startYear == '' || startMonth == ''" role="button" @click="reloadData()">
                Recargar
            </button>
        </footer>
    </div>
</template>

<script>
import { updateObligationsFintoc, loadLogs } from "@/api/fintoc";
import { consoleHandlerError, notificate } from "@/utils/message";
import SimpleButton from "@/components/modals/SimpleButton";

export default {
    name: "ReloadFintocByCompany",
    components: {
        SimpleButton,
    },
    data() {
        return {
            publicPath: "http://" + window.location.hostname,
            actualYear: new Date().getFullYear(),
            loading: false,
            startYear: new Date().getFullYear() - 2,
            startMonth: '01',
            endYear: '',
            endMonth: '',
            today: '',
            inidate: '',
            fintoc_logs: [],
            company_id: '',
            intervalId: null,
        };
    },
    computed: {
        spinner: function () { return `${this.publicPath}/spinner.gif` },
        tipo: function() { return this.product == 'sii'? "Obligaciones": "Movimientos Bancarios"; },
    },
    mounted() {
        this.calculateDates();
        this.loadLogs(this.product);
    },
    methods: {
        showError(row) {
            if (!row.expanded) {
                row.expanded = true;
                row.error_shown = row.error_full;
            } else {
                row.expanded = false;
                row.error_shown = row.error_short;
            }
        },
        async loadLogs(product) {
            const result = await loadLogs(this.rutCompany, product);
            this.fintoc_logs = result.data;
            console.log('this.fintoc_logs:', this.fintoc_logs);
        },
        calculateDates() {
            const today = new Date();
            this.today = today.toISOString().split('T')[0];

            const dateTwoYearsAgo = new Date(today.setFullYear(today.getFullYear() - 2));
            this.inidate = dateTwoYearsAgo.toISOString().split('T')[0];
        },
        reloadData() {
            this.loading = true
            let untilAux = this.endYear + '-' + this.endMonth + '-01'
            if (this.endYear == '' || this.endMonth == '') {
                untilAux = this.today
            }
            let data = {
                since: this.startYear + '-' + this.startMonth + '-01',
                until: untilAux,
                company: this.rutCompany,
                product: this.product
            }
            updateObligationsFintoc(data).then(({ data }) => {
                notificate(
                    `<strong>Éxito!</strong><br>
                    ` + data,
                    "is-success is-light"
                );
                this.intervalId = setInterval(() => {
                    this.loadLogs(this.product);
                }, 5000);
            }).catch(error => {
                consoleHandlerError({ error, empty: true });
                this.$emit("close");
            }).finally(() => {
                this.loading = false
            })
        },
    },
    props: ["rutCompany", "product"],
    created() {
    },
    beforeDestroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    },
};
</script>
<style scoped>
.fecha_title {
    font-weight: bold;
    padding-top: 2px;
    padding-right: 10px;
}
.fechas_td {
    width: 50%;
}
.fechas_table {
    width: 85%;
    margin-left: 15%;
}
.mismatch {
    background-color: #ffcccc;
    color: #333;
}
.log_cell {
    border: solid 1px #000000;
    padding: 1px 8px 1px 4px;
}
.log_fecha {
    font-size: 90%; 
    padding-top: 2px;
}
.log_header {
    color: #ffffff;
    background-color: #4455ff;
    font-weight: bold;
}
.log_title {
    text-align: center;
    margin-bottom: 10px;
    font-weight: bold;
}
.fintoc_log {
    margin: 0 auto;
}
.spinner {
  width: 50px;
  margin-top: -14px;
}
.occurred_today {
    background-color: #ffff99;
}
</style>